import { defaultFetchDownload, defaultFetchImport, defaultFetchWithMeta } from './baseApi';

export type LabelingType = {
	id: number;
	labelable: boolean | null;
	labeled: boolean | null;
	color: string;
	project: {
		id: number;
		cup: string;
		cupType: null;
	};
	ot: {
		id: number;
		code: string;
		description: string | null;
		projectId: number;
	};
	plant: {
		id: number;
		area: null;
		latitude: null;
		longitude: null;
		ut: string;
		companyId: number;
		plantCode: string;
		plantType: string;
		plantName: string;

		createdBy: number | null;
		updatedBy: 1;
		utDescription: string;
	};
	material: {
		id: number;
		code: string;
		type: string | null;
		description: string;
		labelable: boolean | null;
		trackable: boolean | null;
		companyId: number;

		createdBy: number | null;
		updatedBy: number | null;
	};
	serialNumber: string;
	serialNumberDescription: string;
	inventoryAsset: null;
};

type MetaType = {
	total: number;
	currentPage: number;
	perPage: number;
};

const createUrlWithParams = (url: string, searchParams: { currentPage?: number; perPage?: number; searchTerm?: string }) => {
	const params: string[] = [];

	if (searchParams.currentPage) params.push(`page=${searchParams.currentPage}`);
	if (searchParams.perPage) params.push(`perPage=${searchParams.perPage}`);
	if (searchParams.searchTerm) params.push(`term=${searchParams.searchTerm}`);

	if (params.length > 0) {
		url += `?${params.join('&')}`;
	}
	return url;
};

export const getLabeling = async (
	projectId: string,
	searchParams: {
		currentPage?: number;
		perPage?: number;
		searchTerm?: string;
	},
) => {
	const url = createUrlWithParams(`/v0/projects/${projectId}/taggablechecklists`, searchParams);
	return defaultFetchWithMeta<LabelingType[], MetaType>(url);
};

export const exportLabeling = async (projectId: string) => {
	const url = `/v0/projects/${projectId}/taggablechecklists/export`;
	return defaultFetchDownload(url);
};

export const importLabeling = async (projectId: string, file: File) => {
	const url = `/v0/projects/${projectId}/taggablechecklists/import`;
	const formData = new FormData();
	formData.append('file', file);
	formData.append('fileType', 'xlsx');
	return defaultFetchImport(url, formData);
};
